"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rule = void 0;
var NextRuleId = 0;
/**
 * クラスの説明.
 * <pre>
 * ピリオド(.)または句点(。)で終わるところまでが、
 * クラス一覧の概要に説明されるところであり、
 * ピリオド以降は説明の概要には含まれず、クラスの説明に含まれる。
 * このように、JavadocにはHTMLタグを使用することができる。
 * </pre>
 * @param <T1> 総称型パラメータの説明
 * @param <T2> 総称型パラメータの説明
 * @author Wikipedian
 * @author Second author
 * @version 1.6
 * @since 1.0
 */
var Rule = /** @class */ (function () {
    /** @constructor */
    function Rule(name, symbols, action) {
        this.name = name;
        this.symbols = symbols;
        this.action = action;
        this.id = NextRuleId++;
        // this.id = NextRuleId++;
        // Name of the rule.
        // this.name = name;
        // array of symbols. If the symbol begins with ' then it is a regular
        // expression. Otherwise, it is the name of another rule. The array
        // may not be null. For an empty rule, use a zero-length array.
        // this.symbols = symbols;
        // The action. May be undefined.
        // this.action = action;
    }
    // ----------------------------------------------------------------------------
    // Returns string representation of a rule for debugging.
    // ----------------------------------------------------------------------------
    Rule.prototype.toString = function () {
        var str = this.name + ':';
        for (var i = 0; i < this.symbols.length; i++) {
            str += ' ' + this.symbols[i];
        }
        if (0 && this.action) {
            // this prints out the whole function which can be undesirable.
            str += ' action=' + this.action;
        }
        return str;
    };
    return Rule;
}());
exports.Rule = Rule;
//# sourceMappingURL=Rule.js.map